export const SAVE_MIRAKL_OAUTH = 'SAVE_MIRAKL_OAUTH';
export const SAVING_MIRAKL_OAUTH = 'SAVING_MIRAKL_OAUTH';
export const SAVED_MIRAKL_OAUTH = 'SAVED_MIRAKL_OAUTH';
export const SAVE_MIRAKL_OAUTH_ERROR = 'SAVE_MIRAKL_OAUTH_ERROR';

export const saveMiraklOAuthCode = (code, uid) => {
  return { type: SAVE_MIRAKL_OAUTH, code, uid };
};
